<template>
  <!-- 选择弹窗 -->

  <el-dialog v-model="dialogShowFlag" :title="dialogTitle" width="80%" :close-on-click-modal="false">
    <device-change v-model:form="form" :rules="rules" ref="deviceChangeRef" v-if="dialogShowFlag">
      <template #other-form-item>
        <el-form-item label="设备名称" prop="sewageBlockName" class="mb-2">
          <el-input v-model="form.sewageBlockName" placeholder="请输入设备名称" />
        </el-form-item>
        <el-form-item label="正常运行时长" prop="normalRunHours" class="mb-2" labelWidth="auto">
          <el-date-picker v-model="form.normalRunHours" placeholder="请选择运行时长" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" />
        </el-form-item>
      </template>
      <template #slotName3>
        <el-form-item label="运行状态比对值" prop="normalPower" class="mb-2" labelWidth="auto">
          <el-input v-model="form.normalPower" placeholder="请输入运行状态比对值" />
        </el-form-item>
      </template>
    </device-change>

    <template #footer>
      <el-button @click="dialogShowFlag = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, defineExpose, inject, defineEmits, computed } from "vue";
import deviceChange from "../../device-change.vue";
import { ElMessage, ElLoading } from "element-plus";
import { saveKanbanDataApi, getKanbanDataDetailApi } from "@/api/modules/project";
import XEUtils from "xe-utils";

const props = defineProps({
  dialogTitle: { type: String, default: "添加水泵" },
  type: { type: String, default: "Pump" },
  listData: { type: Array, default: () => [] },
});
const receiveTemplateId = inject("templateId");
const receiveProjectModuleId = inject("projectModuleId"); // 默认值为21
const emit = defineEmits(["submit"]);

// 获取子组件实例
const deviceChangeRef = ref(null);
// 控制弹窗显示
const dialogShowFlag = ref(false);
// 提交按钮加载状态
const loading = ref(false);
// 添加编辑设备的key
const blockNameKey = computed(() => {
  if (editblockNameKey.value) return editblockNameKey.value;
  let data = props.listData.find((item) => item.type === props.type);
  return "sewageDistributionRoomWater" + props.type + (data.list.length + 1);
});

// 表单初始值
const initialForm = {
  moduleId: receiveProjectModuleId.value,
  templateId: receiveTemplateId.value,
  sewageBlockName: "",
  normalRunHours: "",
  detail: [
    {
      title: "用电量",
      detailId: 17,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
    {
      title: "功率",
      detailId: 82,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },

    {
      title: "开关信号",
      detailId: 89,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
    {
      title: "运行状态1",
      detailId: 90,
      items: [
        {
          val: "",
          type: "1",
          unit: "",
          dictKey: "",
          dictName: "",
          name: "A",
          deviceIdStr: "",
          deviceName: "",
        },
      ],

      formula: "A",
    },
  ],
  normalPower: "",
};
const form = ref(XEUtils.clone(initialForm, true));

// 字段级校验规则
const rules = {
  dictName: [{ required: false, message: "请选择设备", trigger: "blur" }],
  sewageBlockName: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
  normalRunHours: [{ required: true, message: "请选择运行时长", trigger: "blur" }],
  normalPower: [{ required: true, message: "请输入运行状态比对值", trigger: "blur" }],
};
// 重置表单
const resetForm = () => {
  form.value = XEUtils.clone(initialForm, true);
  deviceChangeRef.value?.resetForm(XEUtils.clone(initialForm, true));
};

function submitForm() {
  deviceChangeRef.value.validateForm().then((valid) => {
    if (valid) {
      loading.value = true;
      let formCopy = JSON.parse(JSON.stringify(form.value));
      formCopy[blockNameKey.value] = {
        detail: formCopy.detail,
        blockId: editBlockId.value || 11,
        sewageBlockName: formCopy.sewageBlockName,
        normalRunHours: formCopy.normalRunHours,
        normalPower: formCopy.normalPower,
      };
      delete formCopy.detail;
      delete formCopy.sewageBlockName;
      delete formCopy.normalRunHours;
      delete formCopy.normalPower;
      delete formCopy.blockId;
      saveKanbanDataApi(formCopy)
        .then((res) => {
          if (res.data.code == 200) {
            loading.value = false;
            dialogShowFlag.value = false;
            ElMessage({
              type: "success",
              message: "保存成功",
            });
            emit("submit");
            resetForm();
          } else {
            loading.value = false;
            ElMessage({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          loading.value = false;
        });
    } else {
      ElMessage.error("指标项不能为空");
    }
  });
}
const getDetail = () => {
  const getDetailLoading = ElLoading.service({ lock: true, text: "Loading", background: "rgba(0, 0, 0, 0.7)" });
  let params = { moduleId: receiveProjectModuleId.value, templateId: receiveTemplateId.value, blockName: editblockNameKey.value, blockId: editBlockId.value };
  getKanbanDataDetailApi(params).then((res) => {
    if (res.data.code == 200) {
      getDetailLoading.close();
      dialogShowFlag.value = true;
      form.value = XEUtils.merge(XEUtils.clone(initialForm, true), res.data.data[editblockNameKey.value]);
    }
  });
};

const editblockNameKey = ref("");
const editBlockId = ref("");
const openDialog = (name, blockId) => {
  if (name) {
    editBlockId.value = blockId;
    editblockNameKey.value = name;
    getDetail();
  } else {
    resetForm();
    editblockNameKey.value = "";
    editBlockId.value = "";
    dialogShowFlag.value = true;
  }
};
defineExpose({ openDialog });
</script>

<style scoped>
.pump-item {
  margin-bottom: 16px;
}
.mb-2 {
  margin-bottom: 12px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.plus-btn {
  margin-top: 12px;
}
</style>
